"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var EditIcon_1 = __importDefault(require("../../../common/Icons/EditIcon"));
var edit_button_module_scss_1 = __importDefault(require("./edit-button.module.scss"));
var EditButton = function (_a) {
    var path = _a.path, className = _a.className;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, edit_button_module_scss_1.default.root) },
        react_1.default.createElement("a", { href: path, className: edit_button_module_scss_1.default.title },
            react_1.default.createElement("span", { className: edit_button_module_scss_1.default.icon },
                react_1.default.createElement(EditIcon_1.default, null)),
            "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0434\u0438\u0437\u0430\u0439\u043D")));
};
exports.default = EditButton;
